import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/me.svg";
import {
  AiFillGithub,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import Achievement from "../Achievement/Achievement";
function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
            I am a Full Stack developer with a keen enthusiasm for acquiring knowledge and engaging in the reverse engineering of frameworks to comprehend their system design intricacies. 
            <br/>
            <br/>
            
            As a Frontend Developer at <b className="purple">CityFlo</b>, I have been responsible for developing and scaling a system that enables interactive engagements between end-users and internal teams.
            <br/>
            <br/>
            During <b className="purple">Google Summer of Code '22</b>, I made active contributions to Rocket.Chat, an open-source communication platform. Additionally, I have actively participated in various contests focused on  <b className="purple">Competitive Programming</b>. My proficiency in these areas has significantly enhanced my ability to approach problem-solving with a unique and well-informed perspective.

            </p>
          </Col>
          <Col md={4} className="myAvtar">

            <img style={{ width: "250px" }} src={myImg} className="img-fluid" alt="avatar" />

          </Col>
        </Row>
        <Achievement />
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/nishant23122000"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/nishant-patel-0b4944174/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/nik_swag_23_12/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
